module.exports = __webpack_public_path__ + "static/media/nouveau-theatre-montreuil.7d96c531.jpg";